var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"countdown-timer"},[_c('div',{class:_vm.$store.state.IS_COMPUTER ? 'time_box_phone' : 'time_box'},[_c('img',{staticClass:"icon",staticStyle:{"width":"20px","height":"20px","margin-right":"5px"},attrs:{"src":require("../../static/img/cartimg/colck.png"),"alt":""}}),_vm._v("\n    课程倒计时："+_vm._s(_vm.formattedTime)+"\n  ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-476a46ae","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CountdownTimer.vue
// module id = null
// module chunks = 